module.exports = __webpack_public_path__ + "img/login_bg.47855b50.png";